import React, { useState, useEffect, useContext } from "react";
import { ProfileContext } from "../context/ProfileContext";
import { ASSOCIATESTATUS_TYPES, HEADERTEXT_TYPES, FB_COLLECTION_PATH } from "../functions/postActionTypes";
import { db } from "../firebase";
import { query, collection, where, doc, onSnapshot } from "firebase/firestore";
import {
  IonContent,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonAvatar,
  useIonAlert,
  IonButton,
  IonFab,
  IonFabButton,
  IonIcon,
} from "@ionic/react";
import { WerkerSchedulerHeader } from "../components/WerkHeader";
import { chatboxOutline } from "ionicons/icons";
import { useHistory } from "react-router";
import { chatFunction } from "../functions/Fx_Chats";
import { useAssociateRequestHandlers } from "../hooks/useAssociateRequestHandlers";
import { isSupportMonkey } from "../constants/supportConstants";

const AssociateProfile: React.FC<any> = ({ match }) => {
  const { profile, buttonColor, myChats } = useContext(ProfileContext);
  const [present] = useIonAlert();
  const [newAssociateStatus, setNewAssociateStatus] = useState(false);
  const history = useHistory();

  const {
    handleSendRequest,
    handleCancelRequest,
    handleAcceptRequest,
    handleDeclineRequest,
    handleFireAssociate: handleFireAssociateBase,
  } = useAssociateRequestHandlers({ profile, presentAlert: present });

  interface ProfileData {
    WerkerUid: string;
    WerkerFirstName: string;
    WerkerLastName: string;
    Company: string;
    Occupation: string;
    WerkerProfilePicURL: string;
    UserBio: string;
  }
  const [ListProfile, setListProfile] = React.useState<ProfileData[]>([
    {
      WerkerUid: "",
      WerkerFirstName: "",
      WerkerLastName: "",
      Company: "",
      Occupation: "",
      WerkerProfilePicURL: "../assets/profilePic.png",
      UserBio: "",
    },
  ]);

  const _handleAssociateClick = async (associateProfile: any) => {
    // console.log(associateProfile);
    var chatExists: boolean = false;
    var chatID: string = "";
    myChats.forEach((chat: any) => {
      // console.log(chat);
      if (chat.DMuid === associateProfile.WerkerUid) {
        // console.log("exist");
        chatExists = true;
        chatID = chat.Key;
      }
    });
    // console.log(chatExists);
    if (chatExists) {
      // console.log("found one", chatID);
      history.push({
        pathname: `/Chat/${chatID}`,
      });
    } else {
      // console.log("no findy");
    }
  };

  interface AsociationData {
    associateStatus: string;
  }
  const [association, setAssociation] = React.useState<AsociationData>({
    associateStatus: "",
  });

  const handleAssociateRequest = async () => {
    if (!ListProfile[0]) return;
    handleSendRequest(
      ListProfile[0].WerkerUid,
      ListProfile[0].WerkerFirstName,
      ListProfile[0].WerkerLastName,
      ListProfile[0].Company,
      ListProfile[0].WerkerProfilePicURL
    );
    setNewAssociateStatus(true);
  };

  const handleAcceptRequestWrapper = async () => {
    if (!ListProfile[0]) return;
    handleAcceptRequest(
      ListProfile[0].WerkerUid,
      ListProfile[0].WerkerFirstName,
      ListProfile[0].WerkerLastName,
      ListProfile[0].Company,
      ListProfile[0].WerkerProfilePicURL
    );
  };

  const handleDeclineRequestWrapper = async () => {
    if (!ListProfile[0]) return;
    handleDeclineRequest(
      ListProfile[0].WerkerUid,
      ListProfile[0].WerkerFirstName,
      ListProfile[0].WerkerLastName,
      ListProfile[0].Company,
      ListProfile[0].WerkerProfilePicURL
    );
  };

  const CancelRequest = async () => {
    if (!ListProfile[0]) return;
    handleCancelRequest(
      ListProfile[0].WerkerUid,
      ListProfile[0].WerkerFirstName,
      ListProfile[0].WerkerLastName,
      ListProfile[0].Company,
      ListProfile[0].WerkerProfilePicURL
    );
  };

  const handleFireAssociate = async () => {
    if (!ListProfile[0]) return;
    handleFireAssociateBase(
      ListProfile[0].WerkerUid,
      ListProfile[0].WerkerFirstName,
      ListProfile[0].WerkerLastName,
      ListProfile[0].Company,
      ListProfile[0].WerkerProfilePicURL
    );
  };

  const AssociatesInformation: React.FC = () => {
    return (
      <IonGrid>
        <IonRow
          className="profileGrid"
        >
          <IonCol>
            <IonAvatar
              className="avatarino"
            >
              <img src={ListProfile[0].WerkerProfilePicURL} alt=""></img>
            </IonAvatar>
          </IonCol>
          <IonCol
            className="title2"
          ></IonCol>
        </IonRow>
        <IonRow
          className="profileGrid"
        >
          <IonCol size="">
            <h1>
              {ListProfile[0].WerkerFirstName} {ListProfile[0].WerkerLastName}
            </h1>
          </IonCol>
        </IonRow>
        <IonRow
          className="profileGrid"
        >
          <IonCol size="11">
            <p>Occupation: {ListProfile[0].Occupation}</p>
            <p>Organization: {ListProfile[0].Company}</p>
          </IonCol>
        </IonRow>

        <AssociateProfileActions />

        <IonRow
          className="profileGrid"
        >
          <IonCol>
            {ListProfile[0].UserBio}
          </IonCol>
          <IonCol
            size="1"
          ></IonCol>
        </IonRow>
      </IonGrid>
    );
  };

  const NotMyAssociateProfile: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow>
          <IonCol
            size="1"
          ></IonCol>
          <IonCol>
            <IonButton
              onClick={handleAssociateRequest}
              color={buttonColor}
              expand="block"
              fill="solid"
            >
              Add Associate
            </IonButton>
          </IonCol>
          <IonCol
            size="1"
          ></IonCol>
        </IonRow>
        <br></br>
      </React.Fragment>
    );
  };

  const PendingAssociateProfile: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow>
          <IonCol
            size="1"
          ></IonCol>
          <IonCol size="10">
            <IonButton
              onClick={handleAcceptRequestWrapper}
              color={buttonColor}
              expand="block"
              fill="solid"
            >
              Accept Request
            </IonButton>
          </IonCol>
          <IonCol
            size="1"
          ></IonCol>
        </IonRow>
        <IonRow>
          <IonCol
            size="1"
          ></IonCol>
          <IonCol size="10">
            <IonButton
              onClick={handleDeclineRequestWrapper}
              color="medium"
              expand="block"
              fill="solid"
            >
              Deny Request
            </IonButton>
          </IonCol>
          <IonCol
            size="1"
          ></IonCol>
        </IonRow>
        <br></br>
      </React.Fragment>
    );
  };

  const PendingSentAssociateProfile: React.FC = () => {
    return (
      <React.Fragment>
        <IonRow>
          <IonCol
            size="1"
          ></IonCol>
          <IonCol>
            <IonButton
              onClick={CancelRequest}
              color={buttonColor}
              expand="block"
              fill="solid"
            >
              Cancel Request
            </IonButton>
          </IonCol>
          <IonCol
            size="1"
          ></IonCol>
        </IonRow>
        <br></br>
      </React.Fragment>
    );
  };

  const MyAssociateProfile: React.FC = () => {
    // Check if this is the Support Monkey profile
    const isSupportMonkeyProfile = isSupportMonkey(ListProfile[0].WerkerUid);

    // const isSupportMonkey = ListProfile[0].WerkerUid === SUPPORT_MONKEY_UID;

    return (
      <React.Fragment>
        <IonRow>
          <IonCol
            size={isSupportMonkeyProfile ? "12" : "8"}
          >
            <IonButton
              color={buttonColor}
              expand="block"
              fill="solid"
            >
              My Associate
            </IonButton>
          </IonCol>
          {!isSupportMonkeyProfile && (
            <IonCol
              size="3"
            >
              <IonButton
                color="medium"
                expand="block"
                fill="solid"
                onClick={handleFireAssociate}
              >
                Drop
              </IonButton>
            </IonCol>
          )}
        </IonRow>
        <br></br>
      </React.Fragment>
    );
  };

  const createChat = async () => {
    // check if the associate already has chats / chat documents
    // then take appropriate action
    try {
      const result = await chatFunction(profile, ListProfile[0], "DM");
      // console.log(result);
      history.push({
        pathname: `/Chat/${result}`,
      });
    } catch (error) {
      // console.log(error);
    }
  };

  const CreateChatFab: React.FC = () => {
    return (
      <React.Fragment>
        <IonFab
          slot="fixed"
          horizontal="end"
          vertical="top"
        >
          <IonFabButton
            style={{
              "--background": "transparent",
              "--background-activated": "rgba(255,255,255,0.08)",
              "--background-hover": "rgba(255,255,255,0.06)",
              "--color": "var(--ion-color-medium-contrast)",
              "--border-radius": "15px",
              "--box-shadow": "0 10px 26px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,255,255,0.10)",
            }}
            // color="medium"
            onClick={createChat}
          >
            <IonIcon
              icon={chatboxOutline}
              color="dark"
            />
          </IonFabButton>
        </IonFab>
      </React.Fragment>
    );
  };

  // Renders Conditional Associate Profile Action Button
  const AssociateProfileActions: React.FC = () => {
    if (association.associateStatus === ASSOCIATESTATUS_TYPES.Associate) {
      return <MyAssociateProfile />;
    }
    if (association.associateStatus === ASSOCIATESTATUS_TYPES.RequestReceived) {
      return <PendingAssociateProfile />;
    }
    if (association.associateStatus === ASSOCIATESTATUS_TYPES.RequestSent) {
      return <PendingSentAssociateProfile />;
    }
    return <NotMyAssociateProfile />;
  };

  useEffect(() => {
    const fetchProfile = async () => {
      //get associate's profile data
      const q = query(collection(db, FB_COLLECTION_PATH.Users), where("uid", "==", match.params.id));
      try {
        const unsubscribe = await onSnapshot(q, (querySnapshot) => {
          if (querySnapshot.docs) {
            const usersMappingArray: ProfileData[] = [];
            querySnapshot.forEach((doc) => {
              const userAttributes = doc.data();

              var bioDisplayed: string = "";
              if (userAttributes.userBio === "Hello!") {
                bioDisplayed = "";
              } else {
                bioDisplayed = userAttributes.userBio;
              }

              // create an object that I can push to the array
              const userObject = {
                WerkerUid: doc.id,
                WerkerFirstName: userAttributes.firstName,
                WerkerLastName: userAttributes.lastName,
                Email: userAttributes.email,
                Company: userAttributes.company,
                Occupation: userAttributes.occupation,
                WerkerProfilePicURL: userAttributes.profilePicURL,
                UserBio: bioDisplayed,
                AssociateStatus: "",
              };

              usersMappingArray.push(userObject);
              setListProfile(usersMappingArray);
            });
          } else {
            // console.log("didn't find any records");
          }
        });
        return () => {
          unsubscribe();
        };
      } catch (err) {
        // console.log(err);
      }
    };
    fetchProfile();
  }, [match.params.id, profile.UserId]);

  useEffect(() => {
    const associationRequest = async () => {
      // get associate's association status
      if (profile.UserId !== "") {
        const unsub = onSnapshot(doc(db, FB_COLLECTION_PATH.UserAssociations, profile.UserId), (doc) => {
          const userAssociationFile = doc.data();
          if (userAssociationFile?.[match.params.id] != null) {
            try {
              setAssociation(userAssociationFile[match.params.id]);
              setNewAssociateStatus(false);
            } catch (err) {
              // console.log(err);
            }
          } else {
            setAssociation({
              associateStatus: "",
            });
          }
        });
        return () => {
          unsub();
        };
      }
    };
    associationRequest();
  }, [ListProfile, match.params.id, newAssociateStatus, profile.UserId]);

  return (
    <IonPage>
      <WerkerSchedulerHeader title={HEADERTEXT_TYPES.AssociatesProfile} />
      <IonContent>
        <IonGrid>
          <AssociatesInformation />
        </IonGrid>
        {association.associateStatus === ASSOCIATESTATUS_TYPES.Associate && <CreateChatFab />}
      </IonContent>
    </IonPage>
  );
};

export default AssociateProfile;
